export const ru = {
    'label-yav': 'Токены, куки и другие секреты, нужно хранить в',
    'link-yav': 'Секретнице',
    title: 'Найдены конфиденциальные данные'
};
